import { render } from "./institutionDetail.vue?vue&type=template&id=15957c98&scoped=true"
import script from "./institutionDetail.vue?vue&type=script&lang=js"
export * from "./institutionDetail.vue?vue&type=script&lang=js"

import "./institutionDetail.vue?vue&type=style&index=0&id=15957c98&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15957c98"]])

export default __exports__